"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pickup_API_PATH = exports.PickupPath = void 0;
const pickup = "/pickup";
exports.PickupPath = {
    pickup,
};
const api_prefix = "api";
const handlePath = ({ path }) => {
    const apiPath = {
        frontend: `${api_prefix}${pickup}/${path}`,
        backend: `/${path}`,
    };
    return apiPath;
};
exports.Pickup_API_PATH = {
    findOrderByPickupCode: (pickupCode) => handlePath({ path: "code/" + pickupCode }),
    findOrderByQRCode: (qrCodeValue) => handlePath({ path: "qrCode/" + qrCodeValue }),
    requestPickupVerification: handlePath({ path: "verify" }),
    getPickupOrderData: (orderNumber) => handlePath({ path: "order/" + orderNumber }),
};
//# sourceMappingURL=pickup.js.map